import { createSlice } from '@reduxjs/toolkit'
const initialState = {
  events: [],
  selectedDate: new Date(),
  currentMonth: new Date(),
  isAddingEvent: false,
  itemsMarkedForDeletion: {},
  editableItems: {},
}

export const configuredServiceEventsSlice = createSlice({
  name: 'configuredServiceEvents',
  initialState,
  reducers: {
    setEvents: (state, action) => {
      state.events = action.payload
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload
    },
    setCurrentMonth: (state, action) => {
      state.currentMonth = action.payload
    },
    setIsAddingEvent: (state, action) => {
      state.isAddingEvent = action.payload
    },
    markItemForDeletion: (state, action) => {
      const eventKey = action.payload
      state.itemsMarkedForDeletion[eventKey] = true
    },
    undoMarkItemForDeletion: (state, action) => {
      const eventKey = action.payload
      delete state.itemsMarkedForDeletion[eventKey]
    },
    clearItemsMarkedForDeletion: state => {
      state.itemsMarkedForDeletion = {}
    },
    setEditableItem: (state, action) => {
      const eventKey = action.payload
      state.editableItems[eventKey] = true
    },
    clearEditableItem: (state, action) => {
      const eventKey = action.payload
      delete state.editableItems[eventKey]
    },
    clearEditableItems: state => {
      state.editableItems = {}
    },
    resetState: state => {
      state.isAddingEvent = false
      state.itemsMarkedForDeletion = {}
      state.editableItems = {}
      state.isGlobalEditMode = false
    },
  },
})

export const {
  setEvents,
  setSelectedDate,
  setCurrentMonth,
  setIsAddingEvent,
  markItemForDeletion,
  undoMarkItemForDeletion,
  setEditableItem,
  clearEditableItem,
  resetState,
} = configuredServiceEventsSlice.actions

export const selectEvents = state => state.configuredServiceEvents.events
export const selectSelectedDate = state => state.configuredServiceEvents.selectedDate
export const selectCurrentMonth = state => state.configuredServiceEvents.currentMonth
export const selectIsAddingEvent = state => state.configuredServiceEvents.isAddingEvent
export const selectItemsMarkedForDeletion = state => state.configuredServiceEvents.itemsMarkedForDeletion
export const selectEditableItems = state => state.configuredServiceEvents.editableItems
export const selectHasItemsMarkedForDeletion = state => Object.keys(state.configuredServiceEvents.itemsMarkedForDeletion).length > 0
export const selectHasEditableItems = state => Object.keys(state.configuredServiceEvents.editableItems).length > 0
export const selectHasPendingChanges = state => {
  const { isAddingEvent, itemsMarkedForDeletion, editableItems } = state.configuredServiceEvents
  return isAddingEvent || Object.keys(itemsMarkedForDeletion).length > 0 || Object.keys(editableItems).length > 0
}

export default configuredServiceEventsSlice.reducer
